document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('.js-show-form-line');
    inputs.forEach((input) => {

        const inpName = input.getAttribute('name');
        const form = input.closest('form');
        const inpGroup = form.querySelectorAll('input[name="'+inpName+'"]');

        let lineId;
        let line;
        let lineInputs;

        inpGroup.forEach((inp) => {

            if(inp.classList.contains('js-show-form-line')){
                lineId = inp.getAttribute('data-id');
                line = document.getElementById(lineId);
                lineInputs = line.querySelectorAll('input,textarea,select')
            }

            inp.addEventListener('change',()=>{
                if(inp.checked && inp.classList.contains('js-show-form-line')){
                    line.classList.remove('hide');
                    lineInputs.forEach((lineInput) => {
                        lineInput.setAttribute('required','required');
                    });
                }
                else{
                    line.classList.add('hide');
                    lineInputs.forEach((lineInput) => {
                        lineInput.removeAttribute('required');
                        lineInput.value = '';
                        lineInput.dispatchEvent(new Event('change'));
                    });
                }

            })
        });


    });
});
